import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HourlyForecast } from '../../../../core/api/api.entities';
import { WeatherApi } from '../../../../core/api/weather/weather-api.service';

@Component({
  selector: 'app-weather-hourly-forecast',
  templateUrl: './hourly-forecast.component.html',
  styleUrl: './hourly-forecast.component.scss',
})
export class HourlyForecastComponent {
  dataSource = new MatTableDataSource<HourlyForecast>();

  displayedColumns: string[] = [
    'date',
    'time',
    'weatherType',
    'temperature',
    'feelsLike',
    'precipitation',
    'wind',
    'cloudCover',
  ];

  loading = true;

  constructor(private weatherApi: WeatherApi) {
    this.weatherApi.getHourlyForecast().subscribe(hourlyForecast => {
      this.dataSource.data = hourlyForecast;
      this.loading = false;
    });
  }
}
